export default __webpack_public_path__ + "static/media/centric_icon.7975b33f.png";